import React from 'react';
import ConversionLink from './ConversionLink';
import './FinalCTA.css';

function FinalCTA() {
  return (
    <section className="final-cta section">
      <div className="container final-cta-container">
        <h2 className="final-cta-headline">Spend $10. Save Hundreds of Hours.</h2>
        <ConversionLink 
          href="https://buy.stripe.com/8x2cN51kR1ORdKQdg85Ne02" 
          className="final-cta-btn btn btn-primary btn-large"
        >
          Get Access Now
        </ConversionLink>
        <p className="final-cta-note">Start working smarter today.</p>
      </div>
    </section>
  );
}

export default FinalCTA;
